<template>
  <Loading v-if="!fullyLoaded" />
  <div v-else>
    <v-container fill-height fluid>
      <v-row justify="center">
        <v-col cols="12" md="4">
          <base-material-stats-card
            color="primary"
            icon="mdi-washing-machine"
            title="Unit ID"
            :value="resource.id"
          />
        </v-col>

        <v-col cols="12" md="4">
          <base-material-stats-card
            color="secondary"
            icon="mdi-calendar"
            title="Last Sync"
            :value="lastSyncTime"
          />
        </v-col>

        <v-col cols="12" md="4">
          <base-material-stats-card
            color="tertiary"
            icon="mdi-calendar"
            title="Last Dispense"
            :value="lastDispenseTime"
          />
        </v-col>
      </v-row>
    </v-container>

    <v-divider class="mb-12" />

    <v-container fill-height fluid>
      <v-row justify="center">
        <v-col md="6" sm="12" v-for="(manifold, i) in resource.manifolds" :key="i">
          <base-material-card
            :color="manifold.color"
            icon="mdi-transit-connection-variant"
            :title="manifold.name"
            class="mb-6"
          >
            <v-list dense>
              <v-list-item>
                <v-row>
                  <v-col cols="8">
                    <v-list-item-title>Chemical</v-list-item-title>
                  </v-col>
                  <v-col cols="4">
                    <v-list-item-title>Pump Id</v-list-item-title>
                  </v-col>
                </v-row>
              </v-list-item>
              <v-divider />
              <v-list-item v-for="(pump, i) in manifold.pumps" :key="i">
                <v-row>
                  <v-col cols="8">
                    <v-list-item-content>{{
                      (pump.chemical && pump.chemical.name) || ''
                    }}</v-list-item-content>
                  </v-col>
                  <v-col cols="4">
                    <v-list-item-content class="align-end">{{
                      pump.unitPumpId
                    }}</v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>

    <v-divider class="mt-6" />

    <AllocationUnitForm
      :sites="sites"
      :resource="resource"
      :submit="submit"
      :destroy="destroy"
      :cancel="cancel"
    />
  </div>
</template>

<script>
import moment from 'moment-timezone';

import EditView from '@/mixins/editView';
import ResourceService from '@/services/resources/allocation_units_service';
import SiteService from '@/services/resources/sites_service';

export default {
  mixins: [EditView],
  components: {
    AllocationUnitForm: () => import('@/components/forms/AllocationUnitForm.vue'),
  },
  data() {
    return {
      resourceParams: {
        include: 'site,manifolds.pumps.chemical',
      },
      urlFragment: 'allocation-units',
      resourceService: ResourceService,
    };
  },
  asyncComputed: {
    sites: {
      get() {
        let filter;
        if (this.siteId) {
          filter = { filter: { id: this.siteId } };
        }

        return SiteService.index(filter).then((sites) => {
          return sites.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
  },
  computed: {
    lastSyncTime() {
      if (this.resource.lastSyncTime) {
        return moment(this.resource.lastSyncTime).fromNow();
      }
      return 'Never';
    },
    lastDispenseTime() {
      if (this.resource.lastDispenseTime) {
        return moment(this.resource.lastDispenseTime).fromNow();
      }
      return 'Never';
    },
  },
};
</script>
